export const DATA_TABLE_LIST = [

    {
        'key': 'picksearchtd',
        'value': 'Pick Management',
    },
    {
        'key': 'pickstatusinquirytd',
        'value': 'Picking Status Inquiry',
    }
];

export const DATA_TABLE_LINE_PROP = {
    lbl_pick_serialno : 'orderKey',
    lbl_alloc_pick : 'orderlinenumber',
    lbl_pre_alloc_pick : 'preAllocPickDtlKey'
};

export enum TAB_LIST {
    lbl_alloc_pick ,
    lbl_pre_alloc_pick ,
    lbl_short_pick,
    lbl_not_fully_alloc ,
    lbl_pick_serialno
}
export enum TAB_LIST_WAVE_CONTROL {
    lbl_not_fully_alloc ,
    lbl_alloc_pick ,
    lbl_pre_alloc_pick,
    lbl_pick_serialno
}

export const PICK_SERIALNO_ERROR ={
    'Allocated_For_SerialNo' : 'Allocated by Serial number and unallocate from pickserial number tab(lsp_Unallocation_Wrapper)'
};

export const PICK_SERIALNO_TAB = {
    pickserialno : 'pickserialnotd'
}

export const PICK_MNGT_URL = {
    'unpickallocate' : 'api/outbound/pick/unpickallocate',
    'getcodelookupvalues' : (storerKey:string,facility:string) => `api/data/codelkup/${CODE_LOOKUP_LISTNAME}/${storerKey}/${facility}/details`
}

export const CODE_LOOKUP_LISTNAME = 'PMCUSTSTS';

export const COLUMN_NAMES = {
    STATUS : 'status',
};


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/outbound/pick-management/services/pick-management-tables.ts